<template>
  <Icon>
    <svg
      slot="svg"
      id="svg3846"
      :class="{
        'arrow': true,
        'arrow--open': open
      }"
      :style="Number.isInteger(defaultRotation) ? { transform: `rotate(${defaultRotation}deg)` } : null"
      :fill="fill"
      xmlns:dc="http://purl.org/dc/elements/1.1/"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 7.2135653 11.224207"
      height="11.224207mm"
      width="7.2135653mm"
    >
      <defs
        id="defs3840" />
      <metadata
        id="metadata3843">
        <rdf:RDF>
          <cc:Work
            rdf:about="">
            <dc:format>image/svg+xml</dc:format>
            <dc:type
              rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
            <dc:title></dc:title>
          </cc:Work>
        </rdf:RDF>
      </metadata>
      <g
        transform="translate(-113.56584,-112.22719)"
        id="layer1">
        <g
          id="g3849"
          transform="matrix(0.26458333,0,0,0.26458333,-56.91149,-174.93603)">
          <path
            d="m 671.08763,1107.7367 -19.52683,19.5268 q -0.50001,0.5 -1.18424,0.5 -0.68423,0 -1.18424,-0.5 l -4.36854,-4.3685 q -0.50001,-0.5 -0.50001,-1.1843 0,-0.6842 0.50001,-1.1842 l 13.97405,-13.9741 -13.97405,-13.974 q -0.50001,-0.5 -0.50001,-1.1843 0,-0.6842 0.50001,-1.1842 l 4.36854,-4.3686 q 0.50001,-0.5 1.18424,-0.5 0.68423,0 1.18424,0.5 l 19.52683,19.5269 q 0.50001,0.5 0.50001,1.1842 0,0.6843 -0.50001,1.1843 z"
            id="path3798"
            style="stroke-width:0.02631648" />
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";
export default {
  name: "DsArrowIcon",
  components: {
    Icon
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    defaultRotation: {
      type: Number,
      default: null
    },
    fill: {
      type: String,
      default: "initial"
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";

.arrow {
  display: block;
  width: 6px;
  height: 10px;
  transform: rotate(90deg);
  transition: $transition-duration;
  &--open {
    transition: $transition-duration;
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-arrow-icon.vue